import { withFormatted } from 'constants/common'

// Minimum number of providers on the page required to display the
// Common Specialties links. Below this the section is hidden.
export const MIN_PROVIDERS_FOR_COMMON_SPECIALTIES = 5

export const providerTypes = {
  THERAPISTS: 'therapists',
  PSYCHIATRISTS: 'psychiatrists',
}

export const seFriendlyPhoneNumber = withFormatted('8339664235')

export const IN_NETWORK_COVERAGE_FOOTNOTE =
  '*Based on an independent analysis of national insurance claims data comparing in-network participation across leading mental health providers. Analysis included a defined set of major behavioral health providers and commercial payers, using standard rate-based methods to identify in-network relationships.'

export const GTMClasses = {
  PROFILE_IMAGE: 'pp-btn profile-image se-friendly',
  CLINICIAN_NAME: 'pp-btn clinician-name se-friendly',
  VIEW_PROFILE_TIMES: 'pp-btn view-profile-times se-friendly',
  CTA: 'sefriendly-cta-book-btn what-is-thriveworks',
  CTA_BOOK_BANNER_FIND_PROVIDER:
    'se-friendly-listing-cta-book-btn bottom-book-banner-section',
  CTA_BOOK_BANNER_CALL_NUMBER:
    'se-friendly-listing-cta-call-btn bottom-book-banner-section',
  CTA_THERAPIST_HUB_BOOK_BANNER_FIND_PROVIDER:
    'se-friendly-therapist-cta-book-btn bottom-book-banner-section',
  CTA_THERAPIST_HUB_BOOK_BANNER_CALL_NUMBER:
    'se-friendly-therapist-cta-call-btn bottom-book-banner-section',
  CTA_PSYCHIATRIST_HUB_BOOK_BANNER_FIND_PROVIDER:
    'se-friendly-psych-cta-book-btn bottom-book-banner-section',
  CTA_PSYCHIATRIST_HUB_BOOK_BANNER_CALL_NUMBER:
    'se-friendly-psych-cta-call-btn bottom-book-banner-section',
  CTA_HERO_SECTION_CALL_PHONE_NUMBER:
    'se-friendly-listing-cta-call-btn hero-section',
  CTA_HERO_SECTION_FIND_PROVIDER:
    'se-friendly-listing-cta-book-btn hero-section',
  CTA_INTERSTITIAL_FIND_PROVIDER:
    'se-friendly-listing-cta-book-btn after3rd-provider-card-book-banner-section',
  CTA_INTERSTITIAL_CALL_PHONE_NUMBER:
    'se-friendly-listing-cta-call-btn after3rd-provider-card-book-banner-section',
  CTA_INSURANCE_PANEL_COST_ESTIMATE:
    'se-friendly-listing-cta-insurance-cost-estimation-btn insurance-section',
  CTA_INSURANCE_PANEL_SELF_PAY_COST:
    'se-friendly-listing-cta-selfpay-cost-btn insurance-section',
  CTA_PROVIDER_CARD_NEXT_OPENING:
    'se-friendly-listing-cta-book-link provider-card-next-opening-section',
}

export enum SeFriendlyBookingButtonLocation {
  SE_FRIENDLY_BOOK_BANNER_SECTION = 'Se-friendly book banner section',
  SE_FRIENDLY_INTERSTITIAL_SECTION = 'Se-friendly interstitial banner section',
}

export const specialties = {
  ANXIETY_THERAPY: 'anxiety-therapy',
  CHILDRENS_THERAPY: 'childrens-therapy',
  CHRISTIAN_COUNSELING: 'christian-counseling',
  COGNITIVE_BEHAVIORAL_THERAPY_CBT: 'cognitive-behavioral-therapy-cbt',
  COUPLES_THERAPY: 'couples-therapy',
  DEPRESSION_THERAPY: 'depression-therapy',
  DIALECTICAL_BEHAVIOR_THERAPY: 'dialectical-behavior-therapy-dbt',
  FAMILY_THERAPY: 'family-therapy',
  GRIEF_COUNSELING: 'grief-counseling',
  MARRIAGE_FAMILY_THERAPY: 'marriage-family-therapy',
  MARRIAGE_COUNSELING: 'marriage-counseling',
  PSYCHIATRIST: 'psychiatrist',
  SEX_THERAPY: 'sex-therapy',
  TRAUMA_PTSD_THERAPY: 'trauma-ptsd-therapy',
}

export const specialtyTypeMapping = {
  area_of_concern: 'areaOfConcern',
  counseling_approach: 'counselingApproach',
  counseling_type: 'counselingType',
}

export const specialtyValueMapping: Record<string, string> = {
  [specialties.ANXIETY_THERAPY]: 'Anxiety',
  [specialties.CHILDRENS_THERAPY]: 'Child Counseling',
  [specialties.CHRISTIAN_COUNSELING]: 'Christian Counseling',
  [specialties.COGNITIVE_BEHAVIORAL_THERAPY_CBT]:
    'Cognitive Behavioral Therapy (CBT)',
  [specialties.COUPLES_THERAPY]: 'Couples/Marriage Counseling',
  [specialties.DEPRESSION_THERAPY]: 'Depression',
  [specialties.DIALECTICAL_BEHAVIOR_THERAPY]:
    'Dialectical Behavior Therapy (DBT)',
  [specialties.FAMILY_THERAPY]: 'Family Counseling',
  [specialties.GRIEF_COUNSELING]: 'Grief',
  [specialties.MARRIAGE_FAMILY_THERAPY]: 'Family Counseling',
  [specialties.MARRIAGE_COUNSELING]: 'Couples/Marriage Counseling',
  [specialties.PSYCHIATRIST]: 'Medication/Psychiatry',
  [specialties.SEX_THERAPY]: 'Sex Therapy',
  [specialties.TRAUMA_PTSD_THERAPY]: 'Trauma / PTSD',
}

export const therapyAndCounseling = [
  specialtyValueMapping[specialties.FAMILY_THERAPY],
  specialtyValueMapping[specialties.MARRIAGE_COUNSELING],
  specialtyValueMapping[specialties.COUPLES_THERAPY],
  specialtyValueMapping[specialties.CHRISTIAN_COUNSELING],
  specialtyValueMapping[specialties.DIALECTICAL_BEHAVIOR_THERAPY],
  specialtyValueMapping[specialties.COGNITIVE_BEHAVIORAL_THERAPY_CBT],
  specialtyValueMapping[specialties.MARRIAGE_FAMILY_THERAPY],
]

export const commonIssues = [
  specialtyValueMapping[specialties.TRAUMA_PTSD_THERAPY],
  specialtyValueMapping[specialties.ANXIETY_THERAPY],
  specialtyValueMapping[specialties.SEX_THERAPY],
  specialtyValueMapping[specialties.DEPRESSION_THERAPY],
  specialtyValueMapping[specialties.GRIEF_COUNSELING],
]

export enum SeFriendlyHubPageTitle {
  THERAPY = 'Find available therapists & counselors near you',
  PSYCHIATRY = 'Find available Psychiatric NPs near you',
}

export enum SeFriendlyPageType {
  CITY = 'city',
  SPECIALTY = 'specialty',
  STATE = 'state',
  HUB = 'hub',
}

export const SCHEMA_ORG_ITEM_LIST_ORDER_UNORDERED =
  'https://schema.org/ItemListUnordered'

export const THRIVEWORKS_SCHEMA_HOME_URL = 'https://thriveworks.com/'
export const THRIVEWORKS_SCHEMA_WEBSITE_ID = 'https://thriveworks.com/#website'
export const THRIVEWORKS_SCHEMA_ORGANIZATION_ID =
  'https://thriveworks.com/#organization'

export const insuranceLogoItems = [
  {
    src: '/images/logo-humana.svg',
    alt: 'Humana insurance logo',
  },
  {
    src: '/images/logo-aetna.svg',
    alt: 'Aetna insurance logo',
  },
  {
    src: '/images/logo-bcbs.svg',
    alt: 'BCBS insurance logo',
    width: 165,
    height: 32,
  },
  {
    src: '/images/logo-cigna.svg',
    alt: 'Cigna insurance logo',
  },
  {
    src: '/images/logo-united-health.svg',
    alt: 'United health insurance logo',
  },
  {
    src: '/images/logo-medicare.svg',
    alt: 'Medicare insurance logo',
  },
]

export const CommonSpecialtyLinkClassnamesMapping = {
  [specialties.ANXIETY_THERAPY]: 'anxiety',
  [specialties.CHRISTIAN_COUNSELING]: 'christian-counseling',
  [specialties.COGNITIVE_BEHAVIORAL_THERAPY_CBT]: 'congnitive-behavioral',
  [specialties.COUPLES_THERAPY]: 'couples-therapy',
  [specialties.DEPRESSION_THERAPY]: 'depression-counseling',
  [specialties.GRIEF_COUNSELING]: 'grief-therapy',
  [specialties.FAMILY_THERAPY]: 'parenting-counseling',
  [specialties.TRAUMA_PTSD_THERAPY]: 'trauma-counseling',
  [specialties.MARRIAGE_COUNSELING]: 'marriage-therapy',
}

export const specialtyValueMappingForBreadcrumbs = {
  [specialties.FAMILY_THERAPY]: 'Family Therapy',
  [specialties.CHILDRENS_THERAPY]: 'Child Counseling',
  [specialties.GRIEF_COUNSELING]: 'Grief Counseling',
  [specialties.MARRIAGE_COUNSELING]: 'Marriage Counseling',
  [specialties.COUPLES_THERAPY]: 'Couples Therapy',
  [specialties.CHRISTIAN_COUNSELING]: 'Christian Counseling',
  [specialties.MARRIAGE_FAMILY_THERAPY]: 'Marriage Family Therapy',
  [specialties.TRAUMA_PTSD_THERAPY]: 'Trauma/PTSD Therapy',
  [specialties.PSYCHIATRIST]: 'Medication/Psychiatry',
  [specialties.SEX_THERAPY]: 'Sex Therapy',
  [specialties.DEPRESSION_THERAPY]: 'Depression Therapists',
  [specialties.ANXIETY_THERAPY]: 'Anxiety Therapists',
  [specialties.DIALECTICAL_BEHAVIOR_THERAPY]: 'DBT',
  [specialties.COGNITIVE_BEHAVIORAL_THERAPY_CBT]: 'CBT',
}

export const reviewPanelItems = [
  {
    id: 1,
    reviewText:
      'Efficient reminders, easy to utilize and caring, effective care from my therapist.',
    dateInfo: 'Feb 2024',
  },
  {
    id: 2,
    reviewText:
      'I love my counselor. She’s been very helpful in me navigating the grief of losing my mother and other family issues. I highly recommend Thriveworks!',
    dateInfo: 'Jan 2024',
  },
  {
    id: 3,
    reviewText:
      'I had a wonderful experience with my practitioner. She was a real professional and helped me tremendously. I will recommend to friends and family.',
    dateInfo: 'Dec 2023',
  },
]

// Frozen because this array is module scope and therefore shared by every request
// a warm server instance handles. Resolving the placeholders in place would leak
// one city's FAQ copy and licensure claim into every subsequent response, so any
// attempt to write back into it should fail loudly rather than silently.
export const FAQsForSpeciality: readonly FAQsPanelItem[] = Object.freeze(
  [
    {
      id: 1,
      question: `What mental health services does Thriveworks offer in {{city}}?`,
      answer: `In {{city}} and the surrounding area, we offer <a href="/therapy/individual-counseling/">individual counseling</a>, <a href="/therapy/couples-therapy/">couples therapy</a>, <a href="/therapy/marriage-counseling/">marriage counseling</a>, <a href="/therapy/family-therapy/">family counseling</a>,{{psychiatryContent}}{{stateLocationsContent}}`,
    },
    {
      id: 2,
      question: `What can I expect from a therapy or psychiatry session in {{city}}?`,
      answer: `When you attend a therapy or psychiatry session with one of our {{city}} providers, you will enter a safe, nonjudgmental space. Your provider will get to know you, including your needs, goals, and preferences for therapy. Then, they’ll create a personalized treatment plan just for you. Moving forward, you’ll work together in each session to manage and overcome your specific challenges.`,
    },
    {
      id: 3,
      question: `Does Thriveworks offer video visits to {{city}} residents?`,
      answer: `Yes, we offer video visits to {{city}} residents. You can schedule a video session with any provider licensed in the state of {{state}}.`,
    },
    {
      id: 4,
      question: 'How is Thriveworks different from other counseling practices?',
      answer:
        'Thriveworks designs care around our clients’ needs — we accept insurance, offer in-person and online care, and offer convenient appointment options in the evenings and on weekends. In addition, our support team is available 7 days a week to help our clients throughout their experience with us.',
    },
  ].map((faq) => Object.freeze(faq))
)

export const AwardsByType = {
  [providerTypes.THERAPISTS]: [
    '/images/Award-Choosing-therapy.webp',
    '/images/Award-VeryWellMind.webp',
  ],
  [providerTypes.PSYCHIATRISTS]: [
    '/images/Psych-Award-Choosing-therapy.webp',
    '/images/Psych-Award-VeryWellMind.webp',
  ],
}

export const HowItWorksProviderListingData = [
  {
    id: 1,
    image: '/images/howItWorksCarousel1.webp',
    heading: 'Get matched to the best therapist or psychiatrist for you',
    description:
      'To begin, easily search online or contact our support team for assistance finding the perfect therapist or psychiatric NP. Select a therapist based on your needs, discuss preferences and goals, and follow a personalized treatment plan.',
  },
  {
    id: 2,
    image: '/images/howItWorksCarousel2.webp',
    heading: 'Complete the intake process and meet your provider ',
    description: `After you've found a provider, you'll complete the intake process as a new client, which will include providing information regarding your past and present medical history, mental health history, medications you’re currently taking. You’ll then meet with your Thriveworks provider for your first session.<br/><br/>You and your provider will talk about your treatment goals, your past history, and begin to determine which methods and approaches might work best for your mental health needs.`,
  },
  {
    id: 3,
    image: '/images/howItWorksCarousel3.webp',
    heading: 'Follow a personalized treatment plan made to fit your needs',
    description: `You'll continue to meet with your provider, typically on a weekly or biweekly basis for therapy, and a monthly basis for psychiatric services. If, after the first few sessions, you're not connecting as well as you'd like to with your current provider, our support team can easily help you find a new therapist or psychiatric NP.`,
  },
]

export const HowItWorksPsychData = [
  {
    id: 1,
    image: '/images/HowItWorksHub1.webp',
    heading:
      'Flexible sessions with a psychiatric NP when & where you need them',
    description:
      '<a href="/app/providers" class="link">Schedule your session today</a> with our medically-trained psychiatric staff. Our NPs offer medication management options that are individually crafted to support your mental health needs. ',
  },
  {
    id: 2,
    image: '/images/HowItWorksHub2.webp',
    heading: 'A dedicated team, there for you at every step',
    description:
      'Thriveworks psychiatric NPs are highly-trained professionals that use prescription medications to treat a variety of mental health conditions. ',
  },
]

export const HowItWorksTherapistsData = [
  {
    id: 1,
    image: '/images/HowItWorksHub1.webp',
    heading: 'Flexible sessions with a therapist when & where you need them',
    description:
      'At Thriveworks, our experienced therapists utilize evidence-based therapeutic approaches, creating a treatment plan that fits your personal preferences and goals for therapy. ',
  },
  {
    id: 2,
    image: '/images/HowItWorksHub2.webp',
    heading: 'A dedicated team, there for you at every step',
    description:
      'Schedule your first session today—many of our providers offer both in-person and online sessions for added convenience. Discover the benefits and mental health insights Thriveworks therapists can offer.',
  },
]

/**
 * Maps state codes to their WordPress location page destinations
 * Used for "States With Availability" links on hub pages
 */
export const stateLocationPageUrls: Record<string, string> = {
  ak: '/alaska-counseling-therapy',
  al: '/alabama-counseling-therapy',
  ar: '/arkansas-counseling-therapy',
  az: '/arizona-counseling-therapy',
  ca: '/california-counseling-therapy',
  co: '/colorado-counseling-therapy',
  ct: '/connecticut-counseling-therapy',
  dc: '/washingtondc-counseling-therapy',
  de: '/delaware-counseling-therapy',
  fl: '/florida-counseling-therapy',
  ga: '/georgia-counseling-therapy',
  hi: '/hawaii-counseling-therapy',
  ia: '/iowa-counseling-therapy',
  id: '/idaho-counseling-therapy',
  il: '/illinois-counseling-therapy',
  in: '/indiana-counseling-therapy',
  ks: '/kansas-counseling-therapy',
  ky: '/kentucky-counseling-therapy',
  la: '/louisiana-counseling-therapy',
  ma: '/massachusetts-counseling-therapy',
  md: '/maryland-counseling-therapy',
  me: '/maine-counseling-therapy',
  mi: '/michigan-counseling-therapy',
  mn: '/minnesota-counseling-therapy',
  mo: '/missouri-counseling-therapy',
  ms: '/mississippi-counseling-therapy',
  mt: '/montana-counseling-therapy',
  nc: '/north-carolina-counseling-therapy',
  nd: '/north-dakota-counseling-therapy',
  ne: '/nebraska-counseling-therapy',
  nh: '/new-hampshire-counseling-therapy',
  nj: '/new-jersey-counseling-therapy',
  nm: '/new-mexico-counseling-therapy',
  nv: '/nevada-counseling-therapy',
  ny: '/new-york-counseling-therapy',
  oh: '/ohio-counseling-therapy',
  ok: '/oklahoma-counseling-therapy',
  or: '/oregon-counseling-therapy',
  pa: '/pennsylvania-counseling-therapy',
  ri: '/rhode-island-counseling-therapy',
  sc: '/south-carolina-counseling-therapy',
  sd: '/south-dakota-counseling-therapy',
  tn: '/tennessee-counseling-therapy',
  tx: '/texas-counseling-therapy',
  ut: '/find-counselor',
  va: '/virginia-counseling-therapy',
  vt: '/vermont-counseling-therapy',
  wa: '/washington-counseling-therapy',
  wi: '/wisconsin-counseling-therapy',
  wv: '/west-virginia-counseling-therapy',
  wy: '/wyoming-counseling-therapy',
}
